/* Silvery Silver revamp: header, drawer, accordions, announcement rotation.
   Plain JS, no dependencies. Safe to load on every page (does nothing if the elements are absent). */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- Desktop dropdowns: Shop mega menu + Help ---------- */
  function initDropdowns(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ss-dropdown]'));
    if (!items.length) return;

    function panelFor(item) {
      var btn = item.querySelector('[data-ss-toggle]');
      return btn ? document.getElementById(btn.getAttribute('aria-controls')) : null;
    }
    function setOpen(item, open) {
      var btn = item.querySelector('[data-ss-toggle]');
      var panel = panelFor(item);
      if (!btn || !panel) return;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }
    function closeAll(except) {
      items.forEach(function (it) { if (it !== except) setOpen(it, false); });
    }
    function isOpen(item) {
      var btn = item.querySelector('[data-ss-toggle]');
      return btn && btn.getAttribute('aria-expanded') === 'true';
    }

    items.forEach(function (item) {
      var btn = item.querySelector('[data-ss-toggle]');
      var panel = panelFor(item);
      if (!btn || !panel) return;
      var openTimer, closeTimer;

      btn.addEventListener('click', function () {
        var willOpen = !isOpen(item);
        closeAll(item);
        setOpen(item, willOpen);
      });

      function enter() {
        if (!finePointer.matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { closeAll(item); setOpen(item, true); }, 150);
      }
      function leave() {
        if (!finePointer.matches) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { setOpen(item, false); }, 200);
      }
      [item, panel].forEach(function (el) {
        el.addEventListener('mouseenter', enter);
        el.addEventListener('mouseleave', leave);
      });
      var scrim = panel.querySelector('.ss-scrim');
      if (scrim) {
        scrim.addEventListener('mouseenter', leave);
        scrim.addEventListener('click', function () { setOpen(item, false); });
      }

      item.addEventListener('keydown', onEsc);
      panel.addEventListener('keydown', onEsc);
      function onEsc(e) {
        if (e.key === 'Escape' && isOpen(item)) { setOpen(item, false); btn.focus(); }
      }
    });

    document.addEventListener('click', function (e) {
      items.forEach(function (item) {
        var panel = panelFor(item);
        if (isOpen(item) && !item.contains(e.target) && !(panel && panel.contains(e.target))) setOpen(item, false);
      });
    });
  }

  /* ---------- Accordions: one branch open per level ---------- */
  function initAccordions(scope) {
    scope.querySelectorAll('[data-ss-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('aria-controls'));
        if (!target) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        var parent = btn.parentElement;
        Array.prototype.forEach.call(parent.children, function (sib) {
          if (sib !== btn && sib.hasAttribute && sib.hasAttribute('data-ss-acc')) collapse(sib);
        });
        if (open) collapse(btn); else expand(btn, target);
      });
    });
    function expand(btn, target) {
      btn.setAttribute('aria-expanded', 'true');
      target.hidden = false;
      var sign = btn.querySelector('.ss-drawer__sign');
      if (sign) sign.textContent = '−';
    }
    function collapse(btn) {
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', 'false');
      if (target) {
        target.hidden = true;
        target.querySelectorAll('[data-ss-acc]').forEach(collapse);
      }
      var sign = btn.querySelector('.ss-drawer__sign');
      if (sign) sign.textContent = '+';
    }
    return collapse;
  }

  /* ---------- Drawer: opens with every branch collapsed (IA State 0) ---------- */
  function initDrawer(root) {
    var drawer = root.querySelector('[data-ss-drawer]');
    var opener = root.querySelector('[data-ss-drawer-open]');
    if (!drawer || !opener) return;
    var closer = drawer.querySelector('[data-ss-drawer-close]');
    var collapse = initAccordions(drawer);

    function open() {
      drawer.querySelectorAll('[data-ss-acc]').forEach(collapse);
      drawer.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      if (closer) closer.focus();
    }
    function close() {
      drawer.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      opener.focus();
    }
    opener.addEventListener('click', open);
    if (closer) closer.addEventListener('click', close);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = drawer.querySelectorAll('a[href], button:not([disabled])');
        var visible = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!visible.length) return;
        var first = visible[0], last = visible[visible.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.matchMedia('(min-width: 1100px)').addEventListener('change', function (mq) { if (mq.matches && !drawer.hidden) close(); });
  }

  /* ---------- Sticky header: shrink on desktop, hide-on-scroll-down on mobile ---------- */
  function initSticky(root) {
    var section = root.closest('.ss-header-section');
    if (!section) return;
    var lastY = window.scrollY;
    var mobile = window.matchMedia('(max-width: 749px)');
    var ticking = false;
    function busy() {
      var drawer = root.querySelector('[data-ss-drawer]');
      return (drawer && !drawer.hidden) || root.querySelector('details[open]') || root.querySelector('[data-ss-toggle][aria-expanded="true"]') ||
        document.querySelector('#cart-notification.active');
    }
    function update() {
      ticking = false;
      var y = window.scrollY;
      var top = section.getBoundingClientRect().top;
      section.classList.toggle('ss-is-stuck', top <= 0 && y > 0);
      if (mobile.matches && !busy()) {
        if (y > lastY + 4 && y > 56) section.classList.add('ss-is-hidden');
        else if (y < lastY - 4) section.classList.remove('ss-is-hidden');
      } else {
        section.classList.remove('ss-is-hidden');
      }
      lastY = y;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Footer accordions (mobile) ---------- */
  function initFooter() {
    document.querySelectorAll('.ss-footer__toggle').forEach(function (btn) {
      if (btn.dataset.ssBound) return;
      btn.dataset.ssBound = '1';
      btn.addEventListener('click', function () {
        var col = btn.closest('.ss-footer__col');
        var open = !col.classList.contains('is-open');
        col.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var sign = btn.querySelector('span:last-child');
        if (sign) sign.textContent = open ? '−' : '+';
      });
    });
  }

  /* ---------- FAQ accordions ---------- */
  function initFaq() {
    document.querySelectorAll('[data-ss-faq]').forEach(function (btn) {
      if (btn.dataset.ssBound) return;
      btn.dataset.ssBound = '1';
      btn.addEventListener('click', function () {
        var answer = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (answer) answer.hidden = open;
        var sign = btn.querySelector('.ss-faq__sign');
        if (sign) sign.textContent = open ? '+' : '−';
      });
    });
  }

  /* ---------- Announcement rotation (up to 3 messages, 6 s, pauses on hover/focus) ---------- */
  function initAnnouncement() {
    document.querySelectorAll('[data-ss-announce]').forEach(function (bar) {
      if (bar.dataset.ssBound) return;
      bar.dataset.ssBound = '1';
      var msgs = bar.querySelectorAll('.ss-announce__msg');
      if (msgs.length < 2 || reduceMotion) return;
      var i = 0, paused = false;
      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });
      bar.addEventListener('focusin', function () { paused = true; });
      bar.addEventListener('focusout', function () { paused = false; });
      setInterval(function () {
        if (paused) return;
        msgs[i].hidden = true;
        i = (i + 1) % msgs.length;
        msgs[i].hidden = false;
      }, 6000);
    });
  }

  function init() {
    document.querySelectorAll('[data-ss-header]').forEach(function (root) {
      if (root.dataset.ssBound) return;
      root.dataset.ssBound = '1';
      initDropdowns(root);
      initDrawer(root);
      initSticky(root);
    });
    initFooter();
    initFaq();
    initAnnouncement();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
